"use strict";

(function($) {
    $(function() {

        if($(window).width() > 768) {

            // PDF READER NEEDS TIME TO BUILD UP
            $('.sticky-container').stick_in_parent({
                offset_top: 100
            });

        }

        $(window).resize(function(){
            if($(window).width() > 768) {
                $('.sticky-container').stick_in_parent({
                    offset_top: 100
                });
            } else {
                $('.sticky-container').trigger("sticky_kit:detach");
            }
        });

    });
})(jQuery);
